<template>
	<div class="italic">Symbol({{ value.data.name }})</div>
</template>

<script>
export default {
	name: 'ArgSymbol',
	props: {value: Object},
}
</script>
